import { render, staticRenderFns } from "./IconBlock.vue?vue&type=template&id=2fe99150&scoped=true&"
import script from "./IconBlock.vue?vue&type=script&lang=js&"
export * from "./IconBlock.vue?vue&type=script&lang=js&"
import style0 from "./IconBlock.vue?vue&type=style&index=0&id=2fe99150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe99150",
  null
  
)

export default component.exports